<template>
    <v-footer id ="landing-footer">
        <v-row>
            <v-col cols="12" md="12" lg="4" xl="4">
                <span>
                    2026. Department of Medical Bioinformatics, University Medical Center Göttingen (UMG), Germany.
                </span>
            </v-col>
            <v-col cols="12" md="12" lg="6" xl="6">
                <span class="footer-element">
                    <router-link to="/imprint" style="color:#fff;text-decoration:None;">
                        Imprint
                    </router-link>
                </span>
                <span class="footer-element">
                    <router-link to="/data-privacy" style="color:#fff;text-decoration:None;">
                        Data Privacy
                    </router-link>
                </span>
                <!--<span class="footer-element">
                    <router-link to="/disclaimer" style="color:#fff;text-decoration:None;">
                        Disclaimer
                    </router-link>
                </span>
                <span class="footer-element">
                    <router-link to="/license" style="color:#fff;text-decoration:None;">
                        License
                    </router-link>
                </span>-->
            </v-col>
            <v-col cols="12" md="12" lg="2" xl="2">
                <img style="border:0px solid red;justify-self: end;" id="logo" src="assets/umg-logo-colored.svg" width="240px" height="40px" />
            </v-col>
        </v-row>
    </v-footer>
</template>

<script setup lang="js">

</script>

<style scoped>

.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5rem;
    background: #66bfbf;
    color: black;
}

#landing-footer {
    width: 100%;
    background-color: #505050;
    justify-items: center;
    color: #fff;
    font-size:14px;
}

.footer-element {
    margin:10px;
}

#legalnotice {
    color: #fff;
    text-decoration: underline;
    cursor: pointer;
}

</style>
